import {useDebugValue, useEffect} from 'react';

import {getObjectValues} from '../../../utils';

function useDetailsModalActions(data) {
    const {
        events: {
            onSettingsChange
        },
        initialSettings,
        changeSettings
    } = data;

    function setSettings(nextSettings) {
        changeSettings(nextSettings);

        onSettingsChange(nextSettings);
    }

    function setSettingsInitial() {
        setSettings(initialSettings);
    }

    function setIsOpen(isOpen) {
        setSettings({
            isOpen
        });
    }

    /* istanbul ignore next */
    function setIsLoading(isLoading) {
        setSettings({
            isLoading
        });
    }

    useEffect(setSettingsInitial, [...getObjectValues(initialSettings)]);

    const result = {
        setSettings,
        setSettingsInitial,
        setIsOpen,
        setIsLoading
    };

    useDebugValue(result);

    return result;
}

export {useDetailsModalActions};
